import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2A0F5B',
        },
        secondary: {
            main: '#EDA24B',
        },
    },
});

export default theme;
